import type { BaseAPIData, ProductCustomOptionsAPIData, NodeAPIData } from 'types/catalog_types';

/** Shared across API Option Data - Option Groups & Options */
export interface BaseOptionAPIData extends BaseAPIData {
  disable_ids: string;
  uid: string;
  required: boolean;
  multiple: boolean;
  custom_options: string | null | ProductCustomOptionsAPIData;
  service_type: string;
  price_multiplier: boolean;
  parent_id: number | null;
  hidden: boolean;
  unavailable: boolean;
  handling_fee: boolean;
  handling_group: '' | 'crate' | 'freight' | 'acrylicfreight';
}

export interface RawOptionGroupAPIData extends BaseOptionAPIData {
  service: null;
  custom_options: null;
  options: RawOptionAPIData[];
  nodes: [];
}

export interface OptionGroupAPIData extends RawOptionGroupAPIData {
  /** Id of product */
  parentId: number | 'order-options';
  options: OptionAPIData[];
}

export interface RawOptionAPIData extends BaseOptionAPIData {
  service: OptionServiceAPIData;
  options: [];
  parent_id: number;
  custom_options: string | null | ProductCustomOptionsAPIData;
  nodes: NodeAPIData[];
}

export interface OptionAPIData extends RawOptionAPIData {
  custom_options: ProductCustomOptionsAPIData | null;
}

export interface DisabledOption {
  id: string;
  by: string;
}

export interface OptionServiceAPIData {
  id: number;
  xml_import_id: number;
  snapshot_id: number;
  uid: string;
  name: string;
  billing_code: string;
  price: string;
  service_type: number;
  apply_to: number;
  tier_pricing: string;
  tier_type: number;
}
